import * as ACTION from './constants';

// ACTION CREATORS
export const globalUIBase = () => ({ type: ACTION.UI_BASE });
export const setGlobalLoadingSpinner = (spinnerState = false, spinnerText = "Loading...") => ({ type: ACTION.UI_LOADING_SPINNER_SET, spinnerState, spinnerText });